import React from "react";
import { Button } from "react-bootstrap";
import WarningModal from "../WarningModal";

const VestingOverrideToggle = ({
  showModal,
  handleConfirmClick,
  handleCancelClick,
  sourceName,
}) => {
  return (
    <WarningModal show={showModal} onHide={handleCancelClick}>
      <div className="remove-text">
        <h4>Are you sure?</h4>
        <p>
          You are overriding the Participant's vesting data for source{" "}
          {sourceName}. Once overridden, vesting data for this source will not
          be auto updated by the system. Any further updates should be handled
          manually
        </p>
        <Button className="remove-btn mr-4" onClick={handleConfirmClick}>
          Yes
        </Button>
        <Button className="cancel-btn" onClick={handleCancelClick}>
          No
        </Button>
      </div>
    </WarningModal>
  );
};
export default VestingOverrideToggle;
